// extracted by mini-css-extract-plugin
export default {"list_team":"listtemf_list_team__bPkKD","list_item":"listtemf_list_item__mVxlt","list":"listtemf_list__TEsGp"};